import React, { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
} from './ui/dialog';

const PasswordDialog = ({ open, onOpenChange, onSuccess, title }) => {
  useEffect(() => {
    if (open) {
      // Skip password, grant access immediately
      onSuccess();
      onOpenChange(false);
    }
  }, [open, onSuccess, onOpenChange]);

  return (
    <Dialog open={false} onOpenChange={onOpenChange}>
      <DialogContent>
        {/* Empty - no password needed */}
      </DialogContent>
    </Dialog>
  );
};

export default PasswordDialog;
